export default "__VITE_ASSET__BX$52ACT__"